enum ACTION_TYPE {
  SPRINT = "SPRINT",
  HSR = "HSR",
  ACCEL = "EXP_ACCEL",
  DECEL = "EXP_DECEL",
}

enum SORT_ORDER {
  ASC = "asc",
  DESC = "desc",
}

enum Language {
  KOR = "ko",
  ENG = "en",
  CHN = "cn",
  ZHO = "zh",
  JPN = "ja",
  SPA = "es",
  POR = "pt",
  IDN = "id",
}

type LanguageItem = {
  text: string
  textEng: string
  value: Language
}

const LANGUAGES: LanguageItem[] = [
  {
    text: "English",
    textEng: "English (US)",
    value: Language.ENG,
  },
  {
    text: "한국어",
    textEng: "Korean",
    value: Language.KOR,
  },
  {
    text: "简体中文",
    textEng: "Simplified Chinese",
    value: Language.ZHO,
  },
  {
    text: "日本語",
    textEng: "Japanese",
    value: Language.JPN,
  },
  {
    text: "Español (España)",
    textEng: "Spanish (Spain)",
    value: Language.SPA,
  },
  {
    text: "Português",
    textEng: "Portuguese",
    value: Language.POR,
  },
  // {
  //   text: "IDN",
  //   value: Language.IDN,
  // },
]

export { ACTION_TYPE, SORT_ORDER, LANGUAGES }
export type { LanguageItem }
